import { TableContainer } from '@app/pages/facts/styles';
import React from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '@components/ui/popover';
import { PopoverClose } from '@radix-ui/react-popover';
import { EllipsisVertical } from 'lucide-react';

const actions = [
  {
    label: 'Edit',
    value: 'edit'
  },
  {
    label: 'Attach Meals',
    value: 'attach'
  },
  {
    label: 'Delete',
    value: 'delete'
  }
];
const TagTable = ({ tags, handleDelete, handleEdit, handleAttach }) => {
  const head = ['Name', 'Category', 'Description', ''];
  return (
    <TableContainer>
      <table>
        <thead>
          <tr>
            {head.map((data, idx) => (
              <th key={idx}>{data}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tags.map((data, index) =>
            data.tags.map((tag) => (
              <tr key={index}>
                <td>{tag.name}</td>
                <td>{tag.category}</td>
                <td>{tag.description}</td>
                <td>
                  <Popover>
                    <PopoverTrigger asChild>
                      <button>
                        <EllipsisVertical />{' '}
                      </button>
                    </PopoverTrigger>
                    <PopoverContent
                      align="end"
                      className="bg-white shadow-[0px_0px_4px_2px_#0000001A] max-w-[131px] border-0 outline-0 rounded-[12px]! ring-0 p-1"
                    >
                      {actions.map((action, idx) => (
                        <PopoverClose
                          onClick={() => {
                            if (action.value === 'edit') {
                              handleEdit(tag);
                              return;
                            }

                            if (action.value === 'delete') {
                              handleDelete(tag._id);
                              return;
                            }

                            if (action.value === 'attach') {
                              handleAttach(tag);
                            }
                          }}
                          key={idx}
                          className="p-2 text-sm font-medium text-left rounded-md transition-all duration-500 ease-in-out focus:border-0 hover:bg-[#549a9a] hover:text-white outline-none
  focus:outline-none
  focus:ring-0
  ring-0"
                        >
                          {action.label}
                        </PopoverClose>
                      ))}
                    </PopoverContent>
                  </Popover>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </TableContainer>
  );
};

export default TagTable;
